// extracted by mini-css-extract-plugin
module.exports = {"videoList":"VideoList_videoList__15437"};